import Layout from "../../components/Layout"
import { Stack } from "@mui/material"
import { Info, Videocam, Movie, VideoFile } from "@mui/icons-material"
import { Route, Routes } from "react-router-dom"
import FileDigitaleDettaglio from "./FileDigitaleDettaglio"
import { useParams } from "react-router-dom"
import { PageTitle } from "../../components/PageTitle"
import { useTranslation } from "react-i18next"
import { useFileDigitale } from "../../hooks/filesDigitali"
import Copie from "../Copie"
import Sequenze from "../Sequenze"
import ProduzioniFilesDigitali from "../ProduzioniFilesDigitali"

export default function FileDigitale() {
  const { fileDigitaleId: id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: fileDigitale } = useFileDigitale(parseInt(id as string))
  const lang = i18n.language

  return (
    <Layout>
      <Stack sx={{ height: "100%", overflow: "hidden" }}>
        <PageTitle
          padding
          border
          title={fileDigitale?.filename || ""}
          breadcrumbs={[
            {
              label: t("general.file_digitali"),
              iconType: Videocam,
              to: `/${lang}/files`,
            },
            {
              label: fileDigitale?.filename || "",
            },
          ]}
          tabs={[
            {
              label: t("general.dettaglio"),
              iconType: Info,
              to: `/${lang}/files/${id}`,
            },
            {
              label: t("general.copie"),
              iconType: VideoFile,
              to: `/${lang}/files/${id}/copie`,
            },
            {
              label: t("general.produzioni"),
              iconType: VideoFile,
              to: `/${lang}/files/${id}/produzioni`,
            },
            {
              label: t("general.sequenze"),
              iconType: Movie,
              to: `/${lang}/files/${id}/sequenze`,
            },
          ]}
        />

        <Routes>
          <Route index element={<FileDigitaleDettaglio />}></Route>
          <Route path={`copie`} element={<Copie fileDigitaleId={Number(id)} />}></Route>
          <Route path={`produzioni`} element={<ProduzioniFilesDigitali fileDigitaleId={Number(id)} />}></Route>
          <Route path={`sequenze`} element={<Sequenze fileDigitale={fileDigitale} fileDigitaleId={Number(id)} />}></Route>
        </Routes>
      </Stack>
    </Layout>
  )
}
